import ProjectSorter from './project-sorter';
import { WindowHelper } from '../WindowHelper';

export default class DesktopActiveStateHandler extends ProjectSorter {
    deactivateAll() {
        const allFilterListItems = document.querySelectorAll('.is-project-list-item');
        for (let i = 0; i < allFilterListItems.length; i++) {
            allFilterListItems[i].classList.remove('is-active');
        }
    }

    activateFilterItemState(node) {
        this.deactivateAll();
        node.classList.add('is-active');
    }

    attachActiveStateEvent() {
        for (let i = 0; i < this.filterItemNodes.length; i++) {
            this.filterItemNodes[i].addEventListener('click', () => {
                this.activateFilterItemState(this.filterItemNodes[i]);
            }, true);
        }
    }

    constructor(filterContainerNodeQS) {
        super(filterContainerNodeQS);
        if (!WindowHelper.isTouchDevice() && WindowHelper.isElementThere(filterContainerNodeQS)) this.attachActiveStateEvent();
    }
}
